"use client";

import { useStore } from "@/stores/appStore";
import { FamousQuote } from "@/stores/slices/userSlice";
import Image from "next/image";
import { usePathname, useSearchParams, useRouter } from "next/navigation";
import { useEffect, useState } from "react";


export function FamousQuoteImage() {
  const [
    famousQuotes,
    initialFamousQuotes,
  ] = useStore((state) => [
    state.famousQuotes,
    state.initialFamousQuotes,
  ]);
  const [famousQuote, setFamousQuote] = useState<FamousQuote | null>(null);
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  useEffect(() => {
    initialFamousQuotes()
  }, [initialFamousQuotes]);

  useEffect(() => {
    if (famousQuotes?.value) {
      const fqidx = searchParams.get('f') as string;
      const code = searchParams.get('code') as string;
      const index = (fqidx && code) ? Number(fqidx) : getRandomIndex(famousQuotes?.value?.length);
      const famousQuote = famousQuotes?.value?.[index];
      setFamousQuote(famousQuote);
      const params = new URLSearchParams(searchParams.toString());
      params.set('f', index.toString());
      // 使用replace方法将新的查询参数添加到URL中
      router.replace(`${pathname}?${params.toString()}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [famousQuotes, pathname, router]);

  if (!famousQuote) {
    return <></>;
  }

  return (
    <Image
      unoptimized={true}
      src={famousQuote.url} width={530} height={620} alt={famousQuote.name} />
  )
}


export function getRandomIndex(max: number, index?: number) {
  // 生成随机数
  return (
    (index && index >= 0) ? index : Math.floor(Math.random() * max)
  );
}
